import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import React from 'react';

import { Box, Flex, Icon, List, Text, Tooltip } from '~/components/blocks';

type Props = {
  name: string;
  content: React.ReactNode;
  children: React.ReactNode;
};

const Root = styled(List.Item)(() =>
  css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  }),
);

export const SettingItem: React.FC<Props> = (props) => {
  const theme = useTheme();

  return (
    <Root>
      <Flex alignItems="center">
        <Text fontWeight="bold" size="m" marginRight={theme.space.s}>
          {props.name}
        </Text>
        <Tooltip content={<Box textAlign="center">{props.content}</Box>}>
          <span>
            <Icon icon="hint" size="xl" color="black" />
          </span>
        </Tooltip>
      </Flex>
      {props.children}
    </Root>
  );
};
